import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getLabelList, addLabel, getLabelDetail, updateLabelStatus, deleteLabel, updateLabel, getMerchantChannelList as _getMerchantChannelList } from '@/services/labelingManagement';
import fanyiPic from '@/assets/fanyi.png';
import moment from 'moment';
export default {
  name: 'labelingManagement',
  i18n: require('./i18n-labelingManagement'),
  components: {},
  data: function data() {
    var _this = this;
    var numberValidate = function numberValidate(rule, value, callback) {
      //			console.log(this.datavalue)
      if (_this.datavalue.type == '0') {
        if (_this.datavalue.startValue < 0 || _this.datavalue.endValue == '' || _this.datavalue.endValue == null) {
          callback(new Error(_this.$t('publicuse.pleaseinput')));
        } else {
          callback();
        }
      } else if (_this.datavalue.type == '1') {
        if (_this.datavalue.startValue == '' || _this.datavalue.startValue == null || _this.datavalue.endValue == '' || _this.datavalue.endValue == null) {
          callback(new Error(_this.$t('publicuse.pleaseinput')));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      fanyiPic: fanyiPic,
      rules: {
        addedDays: [{
          required: true,
          validator: numberValidate,
          trigger: 'blur'
        }],
        productNumber: [{
          required: true,
          validator: numberValidate,
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: this.$t('public.pleaseSelect'),
          trigger: 'change'
        }],
        deliveryChannelId: [{
          required: true,
          message: this.$t('public.pleaseSelect'),
          trigger: 'change'
        }]
      },
      operateType: "",
      //默认语言
      defaultLangObj: {},
      //系统设置中选择的语言
      langList: [],
      //弹框初始化的语言
      initialLangDataList: [],
      errTip: this.$t('public.enterPlease') + this.$t('labelingManagement.labelingName'),
      //标签类型
      labelingTypeList: [],
      //发货渠道
      deliveryChannelList: [],
      //列表数据
      dataList: [],
      isTableLoading: false,
      //新建/修改状态位
      dialogStatus: '',
      textMap: {
        update: this.$t('publicuse.edit') + this.$t('labelingManagement.productLabeling'),
        create: this.$t('publicuse.new') + this.$t('labelingManagement.productLabeling')
      },
      visible: false,
      datavalue: {
        langDataList: [],
        type: undefined,
        startValue: 0,
        endValue: '',
        deliveryChannelId: undefined
      },
      saveLoading: false
    };
  },
  watch: {
    'datavalue.startValue': function datavalueStartValue() {
      if (this.datavalue.type == '0') {
        this.$refs.dataForm.validateField(['addedDays']);
      }
      if (this.datavalue.type == '1') {
        this.$refs.dataForm.validateField(['productNumber']);
      }
    },
    'datavalue.endValue': function datavalueEndValue() {
      if (this.datavalue.type == '0') {
        this.$refs.dataForm.validateField(['addedDays']);
      }
      if (this.datavalue.type == '1') {
        this.$refs.dataForm.validateField(['productNumber']);
      }
    }
  },
  mounted: function mounted() {},
  created: function created() {
    //区分运营方式
    this.deliveryChannel = localStorage.getItem('deliveryChannel');
    if (this.deliveryChannel == 1) {
      //多发货渠道
      this.labelingTypeList = [{
        value: 0,
        text: this.$t('labelingManagement.addedDays')
      },
      // { value: 1, text: this.$t('publicuse.stockQuantity') },
      {
        value: 2,
        text: this.$t('labelingManagement.deliveryChannel')
      }];
    } else {
      //单发货渠道
      this.labelingTypeList = [{
        value: 0,
        text: this.$t('labelingManagement.addedDays')
      }
      // , { value: 1, text: this.$t('publicuse.stockQuantity') }
      ];
    }
    this.getInitialValue();
    this.getList();
    this.getMerchantChannelList();
  },
  methods: {
    //获取localStorage里面的默认语言和系统设置中存的语言list
    getInitialValue: function getInitialValue() {
      var self = this;
      self.defaultLangObj = JSON.parse(localStorage.getItem('defaultLangObj'));
      self.langList = JSON.parse(localStorage.getItem('langList'));
      var _iterator = _createForOfIteratorHelper(self.langList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var nameObj = {};
          //标题
          nameObj.titleName = self.$t('labelingManagement.labelingName') + '(' + item.langName + ')';
          //多语言id
          nameObj.langId = item.langId;
          //名称
          nameObj.title = "";
          if (item.langId == self.defaultLangObj.langId) {
            nameObj.required = true;
          } else {
            nameObj.required = false;
          }
          self.initialLangDataList.push(nameObj);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      self.datavalue.langDataList = _.cloneDeep(self.initialLangDataList);
    },
    //获取列表
    getList: function getList() {
      var self = this;
      self.isTableLoading = true;
      getLabelList().then(function (res) {
        //				 console.log(res.data)
        if (res.data.code == 200) {
          self.dataList = res.data.data;
        } else {
          self.$notification.error({
            message: res.data.message
          });
        }
      }).finally(function () {
        self.isTableLoading = false;
      });
    },
    //获取发货渠道列表
    getMerchantChannelList: function getMerchantChannelList() {
      var self = this;
      var tempData = {
        statusType: 2
      };
      _getMerchantChannelList(tempData).then(function (res) {
        //				 console.log(res.data)
        if (res.data.code == 200) {
          self.deliveryChannelList = res.data.data;
        } else {
          self.$notification.error({
            message: res.data.message
          });
        }
      });
    },
    //跳转商品列表
    goProductList: function goProductList(obj) {
      //			if (obj.type == '0') {
      //				let endValue = new Date(new Date().setDate(new Date().getDate() - obj.startValue)); //当前时间减去已上架天数,计算出上架时间范围
      //				let startValue = new Date(new Date().setDate(new Date().getDate() - obj.endValue));
      //				let productShelfTime = [moment(startValue).format('YYYY-MM-DD'), moment(endValue).format('YYYY-MM-DD')];
      ////				console.log(productShelfTime);
      //				this.$router.push({ name: 'productList', query: { productShelfTime: productShelfTime } });
      //			} else if (obj.type == '1') {
      //				this.$router.push({ name: 'productList', query: { productStockNumMin: obj.startValue, productStockNumMax: obj.endValue } });
      //			} else if (obj.type == '2') {
      //				let deliveryChannelList = [obj.deliveryChannelId];
      //				this.$router.push({ name: 'productList', query: { deliveryChannelList: deliveryChannelList } });
      //			}
    },
    /* 删除按钮 */onDelete: function onDelete(record) {
      var _this2 = this;
      deleteLabel(record.id).then(function (result) {
        if (result.data.code == 200) {
          _this2.$message.success(_this2.$t('public.deleteSuccessfully'));
          _this2.getList();
        } else {
          //					this.$message.error(result.data.message);
          return false;
        }
      });
    },
    /* 启用停用按钮 */onUpdateStatus: function onUpdateStatus(record, status) {
      var _this3 = this;
      //		    console.log(status)
      //调接口
      var tempData = {
        id: record.id,
        status: status
      };
      if (record.updateLabelStatusLoading) return;
      record.updateLabelStatusLoading = true;
      updateLabelStatus(tempData).then(function (result) {
        if (result.data.code == 200) {
          _this3.getList();
          _this3.$message.success(_this3.$t('public.updateSuccessfully'));
        } else {
          _this3.$message.error(result.data.message);
          return false;
        }
      }).finally(function () {
        record.updateLabelStatusLoading = false;
      });
    },
    /* 编辑按钮 */updata: function updata(record) {
      var self = this;
      self.resetdatavalue();

      //获取详情数据
      getLabelDetail(record.id).then(function (res) {
        //				console.log(res.data)
        if (res.data.code == 200) {
          var rs = res.data.data;
          self.datavalue = {
            id: rs.id,
            langDataList: _.cloneDeep(self.initialLangDataList),
            type: rs.type,
            startValue: rs.startValue,
            endValue: rs.endValue,
            deliveryChannelId: rs.deliveryChannelId
          };
          //给多语言集合赋值
          rs.langDataList.forEach(function (item, index) {
            self.datavalue.langDataList.forEach(function (itemModal, index) {
              if (item.langId == itemModal.langId) {
                itemModal.title = item.title;
              }
            });
          });
        } else {
          self.$notification.error({
            message: res.data.message
          });
        }
      });
      self.dialogStatus = 'update';
      self.visible = true;
      this.saveLoading = false;
    },
    /* 添加按钮 */add: function add() {
      var _this4 = this;
      this.dialogStatus = 'create';
      this.resetdatavalue();
      this.$nextTick(function () {
        _this4.visible = true;
      });
      this.saveLoading = false;
    },
    /* 取消按钮 */resetFormDate: function resetFormDate() {
      this.resetdatavalue();
      this.visible = false;
    },
    /* 初始化输入项 */resetdatavalue: function resetdatavalue() {
      var self = this;
      self.datavalue = {
        langDataList: _.cloneDeep(self.initialLangDataList),
        type: undefined,
        startValue: '',
        endValue: '',
        deliveryChannelId: undefined
      };
    },
    typeChange: function typeChange() {
      var self = this;
      //			console.log(self.datavalue)
      self.datavalue.startValue = '';
      self.datavalue.endValue = '';
      self.datavalue.deliveryChannelId = undefined;
    },
    /* 确定添加 */save: function save() {
      var _this5 = this;
      var self = this;
      self.$refs.dataForm.validate(function (valid) {
        if (valid) {
          //调接口
          var newData = self.datavalue;
          _this5.saveLoading = true;
          addLabel(newData).then(function (result) {
            if (result.data.code == 200) {
              self.getList();
              self.$message.success(self.$t('public.saveSuccessfully'));
              self.visible = false;
            } else {
              //								self.$message.error(result.data.message);
              //								return false;
            }
          }).finally(function () {
            setTimeout(function () {
              _this5.saveLoading = false;
            }, 50);
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //弹框更新
    update: function update() {
      var _this6 = this;
      var self = this;
      self.$refs.dataForm.validate(function (valid) {
        if (valid) {
          //调接口
          var newData = self.datavalue;
          _this6.saveLoading = true;
          updateLabel(newData).then(function (result) {
            if (result.data.code == 200) {
              _this6.getList();
              _this6.$message.success(_this6.$t('public.saveSuccessfully'));
              self.visible = false;
            } else {
              //							this.$message.error(result.data.message);
              //							return false;
            }
          }).finally(function () {
            setTimeout(function () {
              _this6.saveLoading = false;
            }, 50);
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};